<ng-container [formGroup]="editService.formGroup">
    <wbo-single-select-edit-control [(ngModel)]="model.data['exclusive']"
                                    [allowClearSelectionOption]="false"
                                    [formControlName]="'exclusive'">
        <wbo-select-options>
            <wbo-select-option [value]="true" label="wbo.report.option.tax.exclusive">
            </wbo-select-option>
            <wbo-select-option [value]="false" label="wbo.report.option.tax.inclusive">
            </wbo-select-option>
        </wbo-select-options>
    </wbo-single-select-edit-control>
</ng-container>
